

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import moment from 'moment-timezone';

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form15";
const form15State = namespace("Form15");

import { form15DataInfoType, form15PartiesInfoType } from '@/types/Information/Form15';
import { partiesDataJsonDataType } from '@/types/Information/json';

import AddPartyForm from './AddPartyForm.vue';
import AddPartyModal from './AddPartyModal.vue';

@Component({
    components:{
        AddPartyForm,
        AddPartyModal        
    }
})
export default class Form15StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;   

    @informationState.State
    public fileNumber: string;

    @form15State.State
    public form15Info: form15DataInfoType;

    @form15State.Action
    public UpdateForm15Info!: (newForm15Info: form15DataInfoType) => void  
    
    @form15State.State
    public currentConsentOrderId: string;

    @form15State.Action
    public UpdateCurrentConsentOrderId!: (newCurrentConsentOrderId: string) => void
    
    dataReady = false;
    updated=0;     
  
    addRespondentFormColor = 'court';
    AddNewRespondentForm = false;

    addAppellantFormColor = 'court';
    AddNewAppellantForm = false;

    partyNames: form15PartiesInfoType[] = [];
    

    partyToEdit = {} as form15PartiesInfoType;
    showPartyWindow = false
    isCreate = true
    partyType = ''   
    seekingRemovedOptions = [
        'appeal',
        'application for leave to appeal',
        'cross appeal',
        'application for leave to cross appeal'
    ]

    partyFields = [
        { key:'organization', label:'Party Type', thClass: 'text-white bg-court', thStyle: '', sortable:false }, 
        { key:'name', label:'Party Name', thClass: 'text-white bg-court', thStyle: '',  sortable:false  },
        { key:'counselName', label:'Counsel Name', thClass: 'text-white bg-court', thStyle: '',  sortable:false  },
        { key:'edit', label:'', thClass: 'text-white bg-court', sortable:false }        
    ]   

    responseOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ]; 

    state = { 
        appellantsInfo: null,
        respondentsInfo: null,
        filingParties: null,
        orders: null,
        otherOrders: null,
        additionalOrders: null,
        signingParties: null       
    }    

    mounted() {
        this.dataReady = false;        
        this.extractInfo();              
    }
    
    public extractInfo(){       

        if(this.currentConsentOrderId){
            this.getForm15Data();
           
        } else { 

            const form15Data = this.form15Info;            
            form15Data.version = this.$store.state.Application.version;
            form15Data.filingParties = [];
            form15Data.signingParties = []; 
            form15Data.appellants = this.partiesJson.appellants
            form15Data.respondents = this.partiesJson.respondents
            form15Data.formSevenNumber = this.fileNumber; 
            
            this.UpdateForm15Info(form15Data);           
            this.revaluateForm15Data();            
            this.saveForm(true);
        }          
    }

    public revaluateForm15Data(){

        const form15Data = this.form15Info;

        for (const respondent of form15Data.respondents){
            if (respondent.firstName && respondent.lastName){                    
                respondent.isOrganization = false;
            } else if (respondent.organization){
                respondent.isOrganization = true;
            }
            if(respondent.solicitor?.counselFirstName && respondent.solicitor?.counselLastName)
                respondent.counselName = respondent.solicitor.counselFirstName+' '+respondent.solicitor.counselLastName                          
            respondent.responding = true;
        }

        for (const applicant of form15Data.appellants){
            if (applicant.firstName && applicant.lastName){
                applicant.isOrganization = false;
            } else if (applicant.organization){
                applicant.isOrganization = true;
            }
            if(applicant.solicitor?.counselFirstName && applicant.solicitor?.counselLastName)
                applicant.counselName = applicant.solicitor.counselFirstName+' '+applicant.solicitor.counselLastName             
            applicant.responding = false;
        }

        const appellants = form15Data.appellants.map(resp=>resp.name)
        const respondents = form15Data.respondents.map(resp=>resp.name)
        form15Data.appellantNames = appellants.join(', ');
        form15Data.respondentNames = respondents.join(', ');

        this.partyNames = [...form15Data.appellants, ...form15Data.respondents]
        this.UpdateForm15Info(form15Data);
    }

    public getForm15Data() {        
       
        this.$http.get('/form15/forms/'+this.currentConsentOrderId)
        .then((response) => {
            if(response?.data?.data){
                const form15Data = response.data.data
                this.UpdateForm15Info(form15Data);
                this.revaluateForm15Data();               
                this.clearStates();                
            }                
        },(err) => {
            console.log(err)        
        });      
    }

    public clearStates(){
        this.state = {
            appellantsInfo: null,
            respondentsInfo: null,
            filingParties: null,
            orders: null,
            otherOrders: null,
            additionalOrders: null,
            signingParties: null            
        }
        this.dataReady = true; 
    }

    public recheckStates(dontFindInvalidFields?){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates(dontFindInvalidFields)
                return 
            }
        }
    }

    public checkStates(dontFindInvalidFields?){  
        
        this.state.appellantsInfo = this.form15Info.appellants?.length>0? null :false;
        this.state.respondentsInfo = this.form15Info.respondents?.length>0? null :false;            
        this.state.filingParties = this.form15Info.filingParties?.length>0? null :false;
        this.state.orders = this.form15Info.orders? null :false;
        this.state.otherOrders = this.form15Info.otherOrders == true || this.form15Info.otherOrders ==false? null :false;
        this.state.additionalOrders = this.form15Info.otherOrders == true && !this.form15Info.additionalOrders? false :null;
        const signingParties = this.form15Info.signingParties?this.form15Info.signingParties:[];
        const signingAppellants = signingParties.filter(party=> !party.responding)
        const signingRespondents = signingParties.filter(party=> party.responding)
        
        this.state.signingParties = (signingAppellants.length>0 && signingRespondents.length > 0)? null :false;
        
        if(dontFindInvalidFields == true) return true 
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    } 

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form15/forms';

        if (this.currentConsentOrderId){
            method = 'put';
            url = '/form15/forms/'+this.currentConsentOrderId;
            const form15Data = this.form15Info;            
            this.UpdateForm15Info(form15Data);

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form15Info,
                    type:'Form15',
                    description:'Consent Order - General'
                }
            }
            this.saveInfo(options, draft);

        } else {
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form15Info,
                    type:'Form15',
                    description:'Consent Order - General'
                }
            }
            this.saveInfo(options, draft);
        }
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentConsentOrderId(response.data.file_id); 
                    }

                    this.clearStates();                                     
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;                
            })
    }

    public addNewRespondent(){
        this.state.respondentsInfo = null
        this.partyToEdit = {} as form15PartiesInfoType
        this.partyType = 'Respondent'
        this.isCreate = true;
        this.showPartyWindow = true;        
    }

    public editRespondent(data) {
        this.partyToEdit = data.item
        this.partyType = 'Respondent';
        this.isCreate = false;
        this.showPartyWindow = true;
    }

    public removeRespondent(data){ 
        const form15Data = this.form15Info;       
        form15Data.respondents.splice(data.index,1);
        form15Data.respondentNames = form15Data.respondents.map(resp=>resp.name).join(', ');
        this.partyNames = [...form15Data.appellants, ...form15Data.respondents]
        this.somePartiesChanged()
        this.UpdateForm15Info(form15Data);
        this.updated ++;        
    }

    public addNewAppellant(){
        this.state.appellantsInfo = null
        this.partyToEdit = {} as form15PartiesInfoType
        this.partyType = 'Appellant'
        this.isCreate = true;
        this.showPartyWindow = true;        
    }

    public editAppellant(data) {
        this.partyToEdit = data.item
        this.partyType = 'Appellant';
        this.isCreate = false;
        this.showPartyWindow = true;        
    }

    public removeAppellant(data){   
        const form15Data = this.form15Info;       
        form15Data.appellants.splice(data.index,1); 
        form15Data.appellantNames = form15Data.appellants.map(resp=>resp.name).join(', ');
        this.partyNames = [...form15Data.appellants, ...form15Data.respondents]        
        this.somePartiesChanged()
        this.UpdateForm15Info(form15Data);
        this.updated ++;        
    }

    public partyChanged(partyCreated){
        if(partyCreated){
            const form15Info = this.form15Info
            const party = JSON.parse(JSON.stringify(this.partyToEdit))
            if(this.partyType == 'Appellant'){
                form15Info.appellants.push(party);
            }
            else if(this.partyType =='Respondent'){
                form15Info.respondents.push(party);
            }
            this.UpdateForm15Info(form15Info)
        }
        this.revaluateForm15Data();
        this.showPartyWindow = false;
        this.somePartiesChanged() 
        this.updated++;
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form15"}) 
    }

    public somePartiesChanged(){   
        this.form15Info.filingParties = [];
        this.form15Info.signingParties = [];    
        this.updated++;
    }    

    public getCounselParty(party){

        if(party.counselName){
            const counsel: form15PartiesInfoType = JSON.parse(JSON.stringify(party))
            counsel.isCounsel = true
            counsel.name = counsel.counselName+', counsel for '+counsel.name
            return counsel
        }        
        return party
    }

}
